import request from '@/utils/request'

export function getUserListApi(query) {
  return request({
    url: '/v1.0/iwrs/project_user/all?' + query,
    method: 'get'
  })
}

// 查询当前项目下所有单位
export function getUnitNo(query) {
  return request({
    url: '/v1.0/iwrs/unit/all_no_page',
    method: 'get',
    params: query
  })
}

// 查询当前项目下所有角色
export function getRoleNo(query) {
  return request({
    url: '/v1.0/iwrs/role/all_no_page',
    method: 'get',
    params: query
  })
}

// 新建用户
export function addUser(data) {
  return request({
    url: '/v1.0/iwrs/project_user/add',
    method: 'post',
    data
  })
}

// 用户详情
export function detailUser(query) {
  return request({
    url: '/v1.0/iwrs/project_user/detail',
    method: 'get',
    params: query
  })
}

// 编辑用户
export function editUser(data) {
  return request({
    url: '/v1.0/iwrs/project_user/update',
    method: 'put',
    data
  })
}

// 删除用户
export function del(data) {
  return request({
    url: '/v1.0/iwrs/project_user/delete',
    method: 'delete',
    data
  })
}

// 导入列表
export function userImport(query) {
  return request({
    url: '/v1.0/iwrs/project_user/can_import_all',
    method: 'get',
    params: query
  })
}

// 查询当前项目下所有角色
export function allUser(query) {
  return request({
    url: '/v1.0/iwrs/role/all_no_page',
    method: 'get',
    params: query
  })
}

// 导入用户
export function importUser(data) {
  return request({
    url: '/v1.0/iwrs/project_user/import',
    method: 'post',
    data
  })
}

// 所有，不分页
export function allUserList(query) {
  return request({
    url: '/v1.0/iwrs/project_user/all_no_page',
    method: 'get',
    params: query
  })
}

// 导出
export function exportUser(params) {
  return request({
    url: '/v1.0/iwrs/project_user/export',
    method: 'get',
    params,
    responseType: "blob"
  })
}

// 启用、禁用
export function enable(data) {
  return request({
    url: '/v1.0/iwrs/project_user/set/enable',
    method: 'post',
    data
  })
}
